import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { sous_category_product } from "../Product_Data";
import {
  faArrowAltCircleRight,
  faHeart,
} from "@fortawesome/free-solid-svg-icons";
import Preloader from "../Preloader";
import { PanierContext } from "../../Store/Panier_context";
import { FavoriteContext } from "../../Store/Favoris_context";
import { AuthContext } from "../AuthContext";
import VusProduct from "./VusProduct";
import API from "../Authentification/api";
import { Button } from "react-bootstrap";
import { getProductImage } from "../../Utils/Cloudinary";
import { isWeightSaleProduct, buildWeightSaleCartProduct } from "../../Utils/weightSale";
import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";

const Products = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sous_category = queryParams.get("sous_category");
  const category = queryParams.get("category");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();

  const [selectedProduct, setSelectedProduct] = useState(null);

  const [showPopUp, setshowPopUp] = useState(false);
  const closePopUp = () => {
    setshowPopUp(false);
    setSelectedProduct(null);
  };
  const openPopUp = (product) => {
    setSelectedProduct(product);
    setshowPopUp(true);
  };

  const { favorites, removeFavorite, addFavorite } =
    useContext(FavoriteContext);
  const { addProductToCart } = useContext(PanierContext);
  const { isLoggedIn } = useContext(AuthContext);

  // FONCTION DE FORMATAGE DU PRIX
  const formatPrice = (price) => {
    const numericValue = typeof price === 'string' ? parseFloat(price) : price;

    return new Intl.NumberFormat('fr-FR', {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(numericValue);
  };

  // Ajout au panier : produits vendus au poids -> montant par défaut
  // (ajustable ensuite dans le panier), autres produits -> comportement normal.
  const handleAddToCart = (product, isUnavailable) => {
    if (isUnavailable) return;

    if (isWeightSaleProduct(product)) {
      addProductToCart(buildWeightSaleCartProduct(product));
      return;
    }

    addProductToCart(product);
  };

  const handleNavigation = () => {
    navigate("/all_products");
  };

  const subCategories = sous_category_product.find(
    (item) => item.category === category
  )?.sous_category || [];

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);

      try {
        const response = await API.get("/products", {
          params: {
            page,
            ...(sous_category ? { sous_category } : {}),
            ...(category ? { category } : {}),
          },
        });

        const result = response.data;

        setProducts(result.data);
        setTotalPages(result.total_pages);
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.error("Erreur lors de la récupération des produits:", error);
        }

      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [sous_category, page, category]);

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Preloader />
      </div>
    );
  }

  return (
    <div className="container-fluid mt-lg-4 mt-1">
      <div className="row">
        <h1 className="col-sm-8 col-9 title mt-2 mt-md-0 text-capitalize">
          {sous_category
            ? `${sous_category}`
            : category
              ? `${category}`
              : "Tous les produits"}
        </h1>
        <div className=" col-sm-4 d-none d-sm-block mt-2">
          <div className="voir_tout">
            <div
              onClick={handleNavigation}
              className="row d-flex align-content-end"
              style={{
                textDecoration: "none",
                color: "#FA7F1B",
                cursor: "pointer",
              }}
            >
              <span className="col text-end">
                Voir tous les produits <FontAwesomeIcon icon={faArrowAltCircleRight} />
              </span>

            </div>
          </div>
        </div>
        {/* Pour les petits écrans  */}

        <div className="d-sm-none col-3 mt-3">
          <div className="voir_tout">
            <div
              onClick={handleNavigation}
              className="row d-flex align-content-end"
              style={{
                textDecoration: "none",
                color: "#FA7F1B",
                cursor: "pointer",
              }}
            >
              <span className="col text-end" style={{ fontSize: '11px' }}>
                Tout voir
                {/* Tout voir <FontAwesomeIcon icon={faArrowAltCircleRight} /> */}
              </span>

            </div>
          </div>
        </div>

      </div>
      <hr style={{ color: "#FA7F1B", height: "0.2rem" }} className="m-0" />
      {category && (
        <div className="dropdown border border-1 p-1 mt-2 d-inline-block" style={{ cursor: "pointer" }}>
          <span
            className="dropdown-toggle texte_brut"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Filtrer par : {sous_category || "Toutes"}
          </span>

          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li
              className="dropdown-item texte_brut"
              onClick={() => navigate(`/products?category=${category}`)}
            >
              Toutes
            </li>

            {subCategories.map((sc, index) => (
              <li
                key={index}
                className="dropdown-item texte_brut"
                onClick={() =>
                  navigate(`/products?category=${category}&sous_category=${sc}`)
                }
              >
                {sc}
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="row mt-lg-3 mt-1">
        {products.length > 0
          ? products.map((product) => {
            const toggleFavorite = (product) => {
              const existing = favorites.find(
                (fav) => fav.product_id === product.id
              );

              if (existing) {
                removeFavorite(existing.id);
              } else {
                addFavorite(product.id);
              }
            };
            const isFavorite =
              favorites &&
              favorites.some((fav) => fav.product_id === product.id);

            const isUnavailable = product.disponibility === "non";
            const weightSale = isWeightSaleProduct(product);

            return (
              <div
                key={product.id}
                className="col-md-3 col-sm-4 col-6 col-lg-2 mb-3"
              >
                <div className={`d-flex flex-column p-1 p-md-2 border-lg-only h-100 ${isUnavailable ? "nm-dispo-off" : ""}`}>
                  <img
                    src={getProductImage(product.image)}
                    className="img_product"
                    alt={product.name}
                    onClick={() => openPopUp(product)}
                    loading="lazy"
                  />
                  <div className="card-body px-0 pb-0 pt-1">
                    <h5
                      className="text-truncate petit_titre mb-1"
                      style={{ textTransform: "none" }}
                      title={product.name}
                    >
                      {product.name}
                    </h5>
                    <p className="card-text petit_titre fw-bold mb-1">
                      {formatPrice(product.price)} FCFA{weightSale ? "/kg" : ""}
                    </p>

                    {!isLoggedIn ? (
                      <div className="my-1">
                        <Button
                          className="border-0 w-100 btn-panier"
                          onClick={() => handleAddToCart(product, isUnavailable)}
                          disabled={isUnavailable}
                          style={{
                            fontSize: "10px",
                            backgroundColor: isUnavailable ? "#adb5bd" : "#0066BD",
                          }}
                        >
                          {isUnavailable ? "Indisponible" : "Panier"}
                        </Button>
                      </div>
                    ) : (
                      <div className="d-flex flex-row justify-content-between align-items-center my-1">
                        <Button
                          className="border-0 btn-panier"
                          onClick={() => handleAddToCart(product, isUnavailable)}
                          disabled={isUnavailable}
                          style={{
                            fontSize: "10px",
                            backgroundColor: isUnavailable ? "#adb5bd" : "#0066BD",
                          }}
                        >
                          {isUnavailable ? "Indisponible" : "Panier"}
                        </Button>
                        <FontAwesomeIcon
                          icon={faHeart}
                          onClick={() => toggleFavorite(product)}
                          style={{
                            cursor: "pointer",
                            color: isFavorite ? "red" : "#FA7F1B",
                            transition: "0.2s",
                            fontSize: "14px"
                          }}
                        />
                      </div>
                    )}
                    {weightSale && !isUnavailable && (
                      <p className="nm-weight-note mb-0">Vendu au poids</p>
                    )}
                    {isUnavailable && (
                      <p className="nm-dispo-label mb-0">Non disponible</p>
                    )}
                  </div>
                </div>
              </div>
            );
          })
          : navigate("/all_products")}
      </div>

      <nav
        aria-label="Pagination"
        className="custom-pagination my-4"
      >
        <button
          className="page-btn"
          disabled={page === 1}
          onClick={() => setPage(1)}
          aria-label="Première page"
        >
          <ChevronsLeft size={14} />
        </button>

        <button
          className="page-btn"
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
          aria-label="Page précédente"
        >
          <ChevronLeft size={14} />
        </button>

        <button
          className="page-btn active"
          aria-current="page"
        >
          {page}
        </button>

        <span className="pagination-total">
          / {totalPages}
        </span>

        <button
          className="page-btn"
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
          aria-label="Page suivante"
        >
          <ChevronRight size={14} />
        </button>

        <button
          className="page-btn"
          disabled={page === totalPages}
          onClick={() => setPage(totalPages)}
          aria-label="Dernière page"
        >
          <ChevronsRight size={14} />
        </button>
      </nav>
      {showPopUp && (
        <VusProduct closePopUp={closePopUp} product={selectedProduct} />
      )}
    </div>
  );
};

export default Products;
